import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { each, pick, reduce, find } from 'lodash';
import { Redirect, Switch, Route, withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem, Popover, OverlayTrigger } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import requiredSync from '../../../components/required-sync';
import orgAwearness from '../../../components/organization-awearness';
import { fetchTVCollectorMappings } from '../../Setup/SetupActions';
import { getTVCollectorMappings } from '../../Setup/SetupReducer';
import { getUserCurrentOrganization } from '../../Auth/AuthReducer';
import requiredSetupMappings from '../../../components/required-setup-mappings';
import SearchForm from '../../../components/search-form';
import NumberDisplay from '../../../components/number-display';
import ProgressBar from '../../../components/progress-bar';

import FeedbackRequestPage from './FeedbackRequestPage';
import BuyerFeedbackPage from './BuyerFeedbackPage';
import SellerFeedbackPage from './SellerFeedbackPage';
import ConversionRatePage from './ConversionRatePage';
import WinRatePage from './WinRatePage';
import AmountWonPage from './AmountWonPage';
import DealSizePage from './DealSizePage';

import {
  resetAll,
  fetchLeaderboardOpportunities,
} from '../../Dashboard/DashboardActions';
import { getHasNoDecisionSetup } from '../../../components/search-form/search-form-reducer';

import { getWinLossLoading, getWinLossLoaded } from '../../Dashboard/DashboardReducer';

import styles from './styles.css';


const MENUS = [
  { url: 'feedback-requests', label: 'Feedback Requests', component: FeedbackRequestPage, filters: { showFeedbackRequests: true } },
  /*
  { url: 'buyer-feedback', label: 'Buyer Feedback', component: BuyerFeedbackPage, filters: { showBuyerFeedbacks: true } },
  { url: 'seller-feedback', label: 'Seller Feedback', component: SellerFeedbackPage, filters: { showSellerFeedbacks: true } },
  { url: 'conversion-rate', label: 'Conversion Rate', component: ConversionRatePage, filters: { showConversionRate: true } },
  { url: 'win-rate', label: 'Win Rate', component: WinRatePage },
  { url: 'amount-won', label: 'Amount Won', component: AmountWonPage },
  { url: 'deal-size', label: 'Average Deal Size', component: DealSizePage },
  */
];

class Leaderboards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
      closeDateRange: [],
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.hanldeReset = this.hanldeReset.bind(this);
    this.handleCloseDateRangeChange = this.handleCloseDateRangeChange.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
    this.props.dispatch(resetAll(false));
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  
  getMenus() {
    const enabled = pick(this.props, ['showFeedbackRequests', 'showBuyerFeedbacks', 'showSellerFeedbacks', 'showConversionRate']);
    return reduce(MENUS, (items, m) => {
      let valid = false;

      if (m.filters) {
        each(m.filters, (v, k) => {
          if (enabled[k] === v) {
            valid = true;
          }
        });
      } else {
        valid = true;
      }

      if (valid) {
        items.push({
          label: m.label,
          component: m.component,
          url: `/leaderboards/${m.url}`,
        });
      }
      return items;
    }, []);
  }

  fetchData() {
    this.setState({ loading: true, loaded: false });
    this.props.dispatch(fetchTVCollectorMappings())
      .then(
        () => {
          if (this.mounted) {
            this.setState({ loading: false, loaded: true });
          }
        },
        () => {
          if (this.mounted) {
            this.setState({ loading: false, loaded: false });
          }
        },
      );
  }

  handleCloseDateRangeChange(closeDateRange) {
    this.setState({ closeDateRange });
  }

  handleFormChange(criteria) {
    const {
      hasNoDecision,
    } = this.props;
    this.props.dispatch(resetAll(false))
      .then(() => {
        this.props.dispatch(fetchLeaderboardOpportunities({ ...criteria }, hasNoDecision))
          .then(
            (results) => {
              const { opportunities, total } = results;
              const returnResults = opportunities.length;
              if (total && returnResults < total) {
                const el = (
                  <div>
                    Your search return more than <NumberDisplay value={total} precision={0} /> results.<br />
                    For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} /> will be returned.
                  </div>
                );
                this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
              }
            },
          );
      });
  }

  hanldeReset() {
    this.props.dispatch(resetAll());
  }

  renderMenu(menus) {
    const {
      location: { pathname },
    } = this.props;

    const activeMenu = find(menus, { url: pathname });
    if (!activeMenu) {
      return null;
    }

    if (menus.length === 1) {
      return (<span>&nbsp;<Fa name="angle-right" className="text-muted" /> {activeMenu.label}</span>);
    }

    const popover = (
      <Popover id="popover-quick-nav" className={styles.dropdownPopover}>
        <ul className={`dropdown-menu open ${styles.dropdown}`}>
          {menus.map((m) => {
            return (
              <LinkContainer exact key={m.url} to={m.url}>
                <NavItem>{m.label}</NavItem>
              </LinkContainer>
            );
          })}
        </ul>
      </Popover>
    );
    return (
      <span>
        <span>&nbsp;<Fa name="angle-right" className="text-muted" />&nbsp;</span>
        <OverlayTrigger
          trigger="click"
          rootClose
          key={pathname}
          placement="bottom"
          overlay={popover}
        >
          <span style={{ cursor: 'pointer' }}><span className="text-active">{activeMenu.label}</span> <Fa name="caret-down" className="text-muted" /></span>
        </OverlayTrigger>
      </span>
    );
  }


  render() {
    const { loading, loaded, closeDateRange } = this.state;
    const {
      location: { pathname },
      searchLoading, searchLoaded,
    } = this.props;

    const isLoading = loading || !loaded;
    const menus = this.getMenus();
    const firstMenu = menus && menus[0] ? menus[0] : null;

    let redirectComp = null;
    const activeMenu = find(menus, { url: pathname });
    if (!isLoading && pathname === '/leaderboards') {
      if (firstMenu) {
        redirectComp = (<Redirect to={firstMenu.url} />);
      }
    }

    const isSearchLoading = !searchLoaded || searchLoading;

    return (
      <div>
        <Helmet title="Leaderboards" />
        <div className="clearfix">
          {isLoading &&
            <div className="container">
              <ProgressBar />
            </div>
          }
          {!isLoading &&
            <div className="container">
              <div className="clearfix">
                {!loading &&
                  <div className="pull-right page-header-control">
                    <SearchForm
                      onSearchChange={this.handleFormChange}
                      onCloseDateRangeChange={this.handleCloseDateRangeChange}
                      onReset={this.hanldeReset}
                      pullRight
                      type="feedback/decisions"
                      requireTeamSelector
                      defaultCriteria={{
                        type: 'groupAND',
                        values: [
                          {
                            tag: 'closeDate',
                            type: 'include',
                            values: 'last-12-months',
                          },
                        ],
                      }}
                      disabledFilters={[]}
                      disabled={isSearchLoading}
                    />
                  </div>
                }
                <h1 className="page-header">
                  Leaderboards
                  {this.renderMenu(menus)}
                </h1>
              </div>
            </div>
          }
          {!isLoading &&
            <div>
              {activeMenu !== null && activeMenu !== undefined && <Helmet title={`${activeMenu.label} | Leaderboards`} />}
              {isSearchLoading && <div className="container"><ProgressBar /></div>}
              {!isSearchLoading &&
                <Switch>
                  {menus.map(m => (<Route key={m.url} exact path={m.url} component={() => (<m.component closeDateRange={closeDateRange} />)} />))}
                </Switch>
              }
              {redirectComp}
            </div>
          }
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const collectorMappings = getTVCollectorMappings(state);
  const organization = getUserCurrentOrganization(state);
  // https://github.com/lumen-software/TruSales/issues/1196
  let showFeedbackRequests = false;
  let showBuyerFeedbacks = false;
  const showSellerFeedbacks = organization.seller_reasons_enabled;
  let showConversionRate = false;
  each(collectorMappings, (client) => {
    each(client.programs, (program) => {
      if ((program.type_name === 'Voice of the Buyer' || program.type_name === 'Win Loss') && program.decision_collector_id !== undefined && program.decision_collector_id !== null) {
        showFeedbackRequests = true;
      }
    });
    showBuyerFeedbacks = client.programs && client.programs.length > 0; // at least one tv program
    showConversionRate = client.programs && client.programs.length > 0; // at least one tv program
  });

  return {
    showFeedbackRequests,
    showBuyerFeedbacks,
    showSellerFeedbacks,
    showConversionRate,
    hasNoDecision: getHasNoDecisionSetup(state),
    searchLoading: getWinLossLoading(state),
    searchLoaded: getWinLossLoaded(state),
  };
}

Leaderboards.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  showFeedbackRequests: PropTypes.bool.isRequired,
  showBuyerFeedbacks: PropTypes.bool.isRequired,
  showSellerFeedbacks: PropTypes.bool.isRequired,
  showConversionRate: PropTypes.bool.isRequired,
  hasNoDecision: PropTypes.bool.isRequired,
  searchLoading: PropTypes.bool.isRequired,
  searchLoaded: PropTypes.bool.isRequired,
};

Leaderboards.defaultProps = {
};

Leaderboards.contextTypes = {
  router: PropTypes.shape({}),
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(orgAwearness(requiredSync(requiredSetupMappings(withRouter(Leaderboards), ['dealType']))));
